import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import React, { useState } from 'react';
import { bgColors } from '../utils/bgColor';
import {BootstrapDialog,BootstrapDialogTitle} from '../FormComopents/Form/CustomDialog'
import { openCurrentFolioDialog } from '../../redux/actions/controlbuttonaction';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
// import Fab from '@mui/material/Fab';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import DialogActions from '@mui/material/DialogActions';
// import AddIcon from '@mui/icons-material/Add';
import AssessmentSharpIcon from '@mui/icons-material/AssessmentSharp';
import ChevronLeftSharpIcon from '@mui/icons-material/ChevronLeftSharp';
import { openAnalysisWindow, openSurveySearchDialog } from '../../redux/actions/controlbuttonaction';
import {useSelector,useDispatch} from 'react-redux'
import IconButton from '@mui/material/IconButton';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import DeleteIcon from '@mui/icons-material/Delete'
import AddShoppingCartSharpIcon from '@mui/icons-material/AddShoppingCartSharp';
import { setMapCentreCord } from '../../redux/actions/mapaction';
import { setFolio } from '../../redux/actions/currentfolioaction';
import {setDrawFeature} from '../../redux/actions/mapaction'
import { v4 as uuidv4 } from 'uuid'
function CurrentFolioDialog(props){

    const currentfolio = useSelector(state => state.currentfolio.currentfolio)
    const [folioname, setFolioname] = useState('')
    const {open, handleClose} = props
    const dispatch = useDispatch()

    // const [dense, setDense] = React.useState(false);
    // const [secondary, setSecondary] = React.useState(false);

    const handleFolioItemClick = (e,item) => {
        e.preventDefault();
        let polygon = {
            id: uuidv4(),
            coords:item.coordinates
        }
        // console.log(polygon)
        dispatch(setMapCentreCord(item.centroid))
        dispatch(setDrawFeature(polygon))
        dispatch(openCurrentFolioDialog)
        
    }

    const handleDeleteFolioItem = (e,item) => {
        e.preventDefault();
        let newArr = currentfolio.filter((element) => element.id !== item.id)
        dispatch(setFolio(newArr))
        dispatch(openCurrentFolioDialog)
        
    }



        return (
            // <div  style = {{maxWidth:'300px'}}>
              <BootstrapDialog
                hideBackdrop
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                scroll="paper"
                sx={{
                    "& .MuiDialog-container": {
                       alignItems: "flex-start",
                       "& .MuiPaper-root": {
                                width: "100%",
                                minHeight:"300px",
                                maxWidth: "300px"  // Set your width here
                            
                            },
                    },
                 }}
                PaperProps={{sx: {position:'fixed' , top:10, left:5} ,style:{borderRadius: 15,
                background:bgColors.default_backgroun_grey
                }}}
              >
                <BootstrapDialogTitle id="survey_search" 
                onClose={handleClose}
                >
                 {/* Current Folio */}
                 <TextField
                    id="Current Folio name"
                    //  label="Current Folio name"
                    placeholder='Enter Folio name'
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                        <AddShoppingCartSharpIcon  sx ={{color: bgColors.font_blue}}/>
                        </InputAdornment>
                    ),
                    }}
                    variant="standard"
                    onChange={(e) => setFolioname(e.target.value)}
                    />
                </BootstrapDialogTitle>
                <DialogContent dividers>
      
          {currentfolio!==undefined &&
            currentfolio.map((item, index) =>
            <div key={index} style={{ marginTop: '0.5rem', marginBottom: '0.5rem', 
                    display: 'flex', 
                    padding: 2,
                    alignItems: 'center',
                    borderBottom:`0.5px solid ${bgColors.grey_400}`,
                    overflow: 'scroll'}} >
                <IconButton onClick={((e) => handleFolioItemClick(e, item))}>
                <LocationOnSharpIcon sx ={{color: bgColors.font_blue}}
               
                />
                </IconButton>
                {[item.survey_no,item.village,item.subdistrict].join(",")}
                <IconButton onClick={((e) => handleDeleteFolioItem(e, item))}>
                <DeleteIcon fontSize='small' sx ={{color: bgColors.red_400, right:'0%'}}/> 
                </IconButton>
             </div>
            )}               
        </DialogContent>
        <DialogActions>
        <Grid container sx = {{display:'flex', direction:'column'}}>
        <Button size='small' sx={{marginRight:'0.5rem'}} 
        onClick={()=> dispatch(openSurveySearchDialog)} 
        >
        <ChevronLeftSharpIcon sx={{ mr: 1}} />
            go back
        </Button>
        <Grid>
        <Divider orientation='vertical' style = {{backgroundColor:bgColors.grey_300}}/>
        </Grid>
        <Button size='small' sx={{marginLeft:'0.5rem'}} 
            onClick={()=>dispatch(openAnalysisWindow)}
            >
        <AssessmentSharpIcon sx={{ mr: 1}} />
            Analyze
        </Button>
        </Grid>
        </DialogActions>
        </BootstrapDialog>
        );
    

}

export default CurrentFolioDialog
